<script>
  /**
   * A layout component that arranges `CartItem` components into a list.
   */
  import CartItem from '@/components/checkout/CartItem'

  export default {
    components: {
      CartItem,
    },
    props: {
      lineItems: {
        type: Array,
        default() {
          return []
        },
      },
    },
    methods: {
      maxQuantity(variant) {
        // When Craft "Allowed Qty" is "any", maxQuantity is null; Math.min(stock, null) → 0 and disables +.
        // Use variant.maxQuantity when set (e.g. 25); when not set, safeguard at 10 so + button still works.
        const stock = variant?.stock ?? Infinity
        const safeguard = 10
        const cap = variant?.maxQuantity != null ? variant.maxQuantity : safeguard
        const max = Math.min(stock, cap)
        return Number.isFinite(max) ? max : safeguard
      },
    },
  }
</script>

<template>
  <div class="divide-y divide-gray-active">
    <slot>
      <CartItem
        v-for="(lineItem, index) in lineItems"
        :key="index"
        :line-item="lineItem"
        :max-quantity="maxQuantity(lineItem.variant)"
        @toggleRemoveItem="$emit('toggleRemoveItem', $event)"
        @removeCartItem="$emit('removeCartItem', $event)"
        @updateQuantity="$emit('updateQuantity', $event)"
        @openTrendingQuestionsModal="$emit('openTrendingQuestionsModal', $event)"
        @openShippingModal="$emit('openShippingModal')"
        @viewDetails="$emit('viewDetails', $event)"
      />
    </slot>
  </div>
</template>